<script>
  import { asnavigate } from '../Utils/asnavigation.js';
  //<span on:click="{() => asglobal()}">asglobal</span>
  import { useNavigate } from 'svelte-navigator';
  import {
    idTrappe,
    nomTrappe,
    currentLocation,
    pathTrappe,
  } from '../stores.js';
  const navigate = useNavigate();

  export let id;
  function pageNext(id) {
    // alert('pageNext');
    $idTrappe = id;
    $nomTrappe = titreArr[id];
    // console.log(`idTrappe - card : ${$idTrappe}`);
    // console.log(`nomTrappe - card : ${$nomTrappe}`);
    // navigate('1');
    pathTrappe.add($currentLocation, ['idTrappe', 'nomTrappe']);
    asnavigate(navigate, '1');
  }
  let titreArr = new Array();
  let descArr = new Array();
  let linkArr = new Array();

  titreArr[1] = 'Métallique ';
  descArr[1] = `Cadre et vantail en tôle`;
  //linkArr[]='';

  titreArr[2] = 'Alu hydro';
  descArr[2] = `Cadre alu / plaque de plâtre hydrofuge
Trappe de visite pour milieu humide`;

  titreArr[3] = 'Vide sanitaire';
  descArr[3] = `Cadre et vantail en tôle
Trappe de visite extérieur`;

  titreArr[4] = 'Multi-étanchéités';
  descArr[4] = `Cadre alu / plaque de plâtre hydrofuge
Trappe de visite pour milieu à condition spécifique`;

  titreArr[5] = 'Coupe feu';
  descArr[5] = `Cadre alu / plaque de plâtre résistante au feu
Trappe de visite pour milieu à risque incendie`;

  let titre = titreArr[id];
  let desc = descArr[id];
</script>

<button
  on:click="{() => pageNext(id)}"
  class="relative flex flex-col min-w-0 break-words w-full mb-6 transition duration-300 transform hover:scale-105 group "
  aria-label="View item"
  title="View item"
>
  <!-- "./statics/trappe-alu-hydro.jpg" -->
  <img
    alt="..."
    src="./statics/trappes/t{id}.png"
    class="w-full align-middle"
    style="background: #f5f5f5;"
  />
  <blockquote class="relative mt-5 mb-4 text-left" style="width:100%;">
    <h4 class="as-titre-trappe">{titre}</h4>
    <p class="as-text-trappe text-sm font-light mt-0 " style="min-height:60px;">
      {desc}
    </p>
  </blockquote>
</button>

<style>
  .as-titre-trappe {
    font-size: 18px;
    line-height: 19px;
    text-transform: uppercase;
  }
  .as-text-trappe {
    font-family: 'introlight';
    font-size: 14px;
    line-height: 17px;
    padding-top: 4px;
  }
</style>
